import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface Cohort {
	id?: number
	name: string
	curso_id: number
	progress?: string
	'type-course'?: string
	status?: string
}

interface Course {
	id: number
	name: string
	'type-course'?: string
	company: string
	curso_id?: number
	progress?: string
	status?: string
	total_classes?: number
}

interface MatriculateState {
	classSelect: Cohort | Course | undefined
}

const initialState: MatriculateState = {
	classSelect: undefined,
}

export const matriculateSlice = createSlice({
	name: 'matriculate',
	initialState,
	reducers: {
		setClassSelect: (state, { payload }: PayloadAction<Cohort | Course>) => {
			state.classSelect = payload
		},
	},
})

export const matriculateCreators = matriculateSlice.actions

export const matriculateReducer = matriculateSlice.reducer
